module.exports = __webpack_public_path__ + "img/christiane_g.5fe24c20.jpg";